var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.classes},[(_vm.icon)?_c('span',{staticClass:"InlineList-divider"},[_c('CloIcon',{attrs:{"symbol":_vm.icon,"size":"sm"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }